<div class="hamburger">
  <h2>Requesting Department Limit</h2>
</div>

<div class="container-fluid bg">
  <div class="container">
    <div class="row align-items-center mt-3 bgFilter">
      <!-- Left: Dropdown -->
      <div class="col-sm-4 col-md-4">
        <label class="form-control-label req">Department Name</label>
        <ng-select id="scheme" [items]="AgencyLists" [(ngModel)]="agency" bindLabel="agencyName" appearance="outline"
          [closeOnSelect]="true" [clearable]="true" (ngModelChange)="agencyChange()" class="form-control"
          appNgSelectInputRestriction>
        </ng-select>
      </div>

      <!-- Right: Total Amount Display -->
      <div class="col-sm-6 col-md-6 mt-3 d-flex justify-content-end align-items-center" *ngIf="filteredList.length !== 0">
        <div>
          <h6 class="total">
            {{ agency?.name }}
            Total Amount Available:
            <span>₹{{ totalAvailableAmount | number:'1.0-0' }}</span>
          </h6>
        </div>
      </div>

    </div>
  </div>

  <!-- Table -->
  <div class="row tableDesign" *ngIf="filteredList.length !== 0">
    <div class="col-md-12 px-5 mt-3" id="entities">
      <table class="table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name of the Projects</th>
            <th>AS Amount</th>
            <th>Total funds Received</th>
            <th>Total funds Spent</th>
            <th>Total Amount Available</th>
            <th>Excess Amount Spent</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dept of filteredList; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ dept.PROJECT_NAME }}</td>
            <td>₹{{dept.AS_AMOUNT |indianRupee}}</td>
            <td>₹{{ dept.TOTAL_FUNDS_RECEIVED |indianRupee }}</td>
            <td>₹{{ dept.EXPENDITURE |indianRupee}}</td>
            <td>₹{{ dept.BALANCE |indianRupee }}</td>
            <td [ngClass]="{ 'text-danger': dept.EXCESS_AMOUNT_SPEND < 0 }">
              ₹{{ dept.EXCESS_AMOUNT_SPEND}}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- PrimeNG paginator -->
      <p-paginator [rows]="5" [totalRecords]="tempFiltered.length" [rowsPerPageOptions]="[5, 10, 20]"
        (onPageChange)="paginate($event)" styleClass="mt-4 justify-content-center"></p-paginator>
    </div>
  </div>
</div>